import Button from '@vromo/ui/components/Button';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import React, { memo } from 'react';
import styles from '../../reportRoot.style';
import { qaLabelReports } from '../../../../../../common-qa-labels/reports'

interface Props {
    openFilters: () => void;
    filterDateText: string;
    filterCount: number;
}

const FilterButton = ({ openFilters, filterDateText, filterCount }: Props) => (
    <>
        <div className={styles.filtersContainer}>
            <FontAwesome icon="calendar" weight="regular" />
            <div className={styles.filterDateText}>{filterDateText}</div>
        </div>
        <Button data-testid={qaLabelReports.filterButton} primary onClick={openFilters} className={styles.filterButton}>
            {filterCount > 0 && <div className={styles.filterCount}>{filterCount}</div>}
            <FontAwesome icon="filter" weight="solid" />
        </Button>
    </>
);

export default memo(FilterButton);
